import WorkSessionForm from './WorkSessionForm';
export default function NewWorkSession() {
  return <WorkSessionForm mode="new"/>;
}
